export { ComponentMap } from './component-map';
